import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/routes";
import store from "@/stores";
import configuration from "@/configuration";
import registerAxios from "@/mixins/axios";
import registerEnv from "@/mixins/env";
import can from "@/directives/can";
import "@/utils/inactiveMonitor";
import EventBus from "@/utils/global-events.js";
import VueClipboard from "vue3-clipboard";
import registerBaseComponents from "@/configuration/registerBaseComponents";
import { plugin, defaultConfig } from "@formkit/vue";
import "@formkit/themes/genesis";
import S3UploaderPlugin from "@/plugins/s3-uploader-plugin";
import clickOutside from "@/directives/clickOutside";

const app = createApp(App);

app.use(router);
app.use(store);
app.use(VueClipboard);
app.use(
  plugin,
  defaultConfig({
    plugins: [S3UploaderPlugin],
  }),
);

registerAxios(app);
registerEnv(app);
registerBaseComponents(app);
app.directive("click-outside", clickOutside);
app.directive("can", can);

app.config.globalProperties.EventBus = EventBus;

configuration.init().then(() => {
  app.mount("#app");
});
